/**
 * Whether this browser will show motion: it can be asked, and its reader
 * has not asked for less. A browser that cannot be asked gets none, and so
 * does the prerender, which has no window.
 */
export function showsMotion(): boolean {
    return (
        typeof window !== "undefined" &&
        typeof window.matchMedia === "function" &&
        !window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
}
